import { createContext, useContext } from 'react';

export const AuthContext = createContext();

// Custom hook for AuthContext
const useAuth = () => {
    return useContext(AuthContext);
}

export { useAuth, AuthContext as default }
